module.exports = __webpack_public_path__ + "490c3d78bf6961cad04caed1e26d9d0c.png";